import React, { useState } from 'react';
import { Button, Modal, Table, Form, Row, Col, Breadcrumb } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DatePicker, DatePickerInput } from "rc-datepicker";
import * as moment from "moment";
import "moment/min/moment-with-locales";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Input } from "semantic-ui-react";
import ReactTable from "react-table";
import "react-table/react-table.css"; 
import 'react-dual-listbox/lib/react-dual-listbox.css';
import _ from "lodash";
import DualListBox from 'react-dual-listbox';

//const configData= require('config');
const configData = require( '../../config.json');


const initialValues = {
    weight: '',
    height: '',
    date: '',
    
    
}
const listoptions = [
    { value: 'one', label: 'Option One' },
    { value: 'two', label: 'Option Two' },
];
export default class ExecutableProcess extends React.Component  {
    constructor(...args) {
        super(...args)
 
        this.state = {
            show: false,
            selectedOption: null,  
            
                process_name:'',
                process_initial_starttime : "",  
                process_owner : "",             
                process_parameters : "",
                sched_interval_min : "",             
                auto_or_manual : "",                            
                startdate : "",
                enddate : "",
                process_status : "",
                seq_of_prog_id : "",
                _id:undefined,
                
                columns:[],
                executableprocesslist:[], 
                originalexecutableprocesslist:[],
                searchInput: "",
                filteredData: [],
                chkisactive:true,           
                userrole:{create:''},
                listselected: [],
                listoptions:[              
                ]
        }
        this.setState({Labels:[], isFetching: true});
        this.fetchLabelMessagesAPI();
       
    }     
    
    componentDidMount() {
        this.fetchExecutableProgramList();
        this.fetchexecutableprocesslist();
        this.getColumns();
    }

    getColumns = () => {
        var rolelist= JSON.parse(localStorage.getItem("rolelocation"));
        console.log(rolelist);
        var primaryroleval=  localStorage.getItem("primaryrolesession");
        var selectedrolelocation=undefined;
        _.forEach(rolelist, function(value) {
             
            if(primaryroleval==value.name){
                selectedrolelocation=value;
            }
            
        });
       
        var userrl =_.find(selectedrolelocation.location, function(obj) {
            return obj.location === 'Executables';
        });

        const formatSeqCell = (value) => {
             

            if (value) {
              return value+',';
            } else {
              return "-";
            }
          };

        let columns = [
            {
                Header: "id",
                accessor: "id",
                sortable: true,
                show: true,
                displayValue: "id",
                width: 50 
              },   
          {
            Header: "Name",
            accessor: "process_name",
            sortable: true,
            show: true,
            displayValue: "Process Name",
            width: 180 
          },          
          {
            Header: "Initial StartTime",
            accessor: "process_initial_starttime",
            sortable: true,
            show: true,
            displayValue: "Initial StartTime",
            width: 100 
          },
          {
            Header: "Owner",
            accessor: "process_owner",
            sortable: true,
            show: true,
            displayValue: "Process Owner",    
            width: 120         
          },          
          {
            Header: "Parameter",
            accessor: "process_parameters",
            sortable: true,
            show: true,
            displayValue: "Process Parameter",
            width: 100 
          },  
          {
            Header: "Schedule Interval Min",
            accessor: "sched_interval_min",
            sortable: true,
            show: true,
            displayValue: "Schedule Interval Min",
            width: 100 
          },       
          {
            Header: "Type",
            accessor: "auto_or_manual",
            sortable: true,
            show: true,
            displayValue: "Process Type",
            width: 100 
          },  
          {
            Header: "Start Date",
            accessor: "startdate",
            sortable: true,
            show: true,
            displayValue: "Start Date"
          },
          {
            Header: "End Date",
            accessor: "enddate",
            sortable: true,
            show: true,
            displayValue: "End Date"
          },
          {
            Header: "Status",
            accessor: "process_status",
            sortable: true,
            show: true,
            displayValue: "Status",
            minWidth: 70,
            width: 70,
          },   
          {
            Header: "Sequence ID",
            accessor: "seq_of_prog_id",
            sortable: true,
            show: false,
            displayValue: "Sequence ID",
            minWidth: 70,
            width: 70,
          },   
          {
            Header: "all list",
            accessor: "seq_list",
            sortable: true,
            show: false,
            displayValue: "seq_list",
            minWidth: 70,
            width: 70,
          }, 
          {
            Header: "Seq List",
            accessor: "seq_select_list",
            sortable: true,
            show: true,
            displayValue: "seq list",
            minWidth: 70,
            width: 70,
            Cell: ({ value }) => formatSeqCell(value),
          }, 
          {
            Header:"Edit",
            maxWidth: 100,
            minWidth: 40,
            width: 40,
            //show:userrl.edit=='Y'?true:false,
            Cell:row => (<div className="grdbuttoncontainer"><div className="editcontainer"> <a
                className="editbutton"
                aria-label="Edit"
                onClick={(event) => this.handleEditClick(row,event)}
            >
                <i className="">
                    <img
                        alt="Edit"
                        className=""
                        src="/images/edit_icon.png"
                    />
                </i>
            </a></div></div>)
          }, 
          {
            Header:"Delete",
            maxWidth: 100,
            minWidth: 58,
            width: 58,
            //show:userrl.delete=='Y'?true:false,
            Cell:row => (<div className="grdbuttoncontainer"><div className="deletecontainer"> <a
                className="deletebutton"
                aria-label="Delete"
                onClick={(event) => this.handleDeleteClick(row,event)}
            >
                <i className="">
                    <img
                        alt="Delete"
                        className=""
                        src="/images/delete_icon.png"
                    />
                </i>
            </a></div></div>)
          }

        ];
        this.setState({ columns });
      };
   
      fetchexecutableprocesslist = () => {
        this.setState({...this.state, isFetching: true});
        
        axios
        .get(configData.SERVER_URL+`fincorp_getexecutableprocesslist` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*"
            }
        })
        .then(
            res=>  {this.setexecutableprocesslist(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    };

    
    setexecutableprocesslist=(result)=>{ 
        
        var rolelist= JSON.parse(localStorage.getItem("rolelocation"));
        console.log(rolelist);
        var primaryroleval=  localStorage.getItem("primaryrolesession");
        var selectedrolelocation=undefined;
        _.forEach(rolelist, function(value) {
             
            if(primaryroleval==value.name){
                selectedrolelocation=value;
            }
            
        });
       
        var userrl =_.find(selectedrolelocation.location, function(obj) {
            return obj.location === 'Executables';
        });
        debugger;

        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){            
            this.setState({executableprocesslist: result,originalexecutableprocesslist:result,userrole: userrl, isFetching: false});
            this.globalSearch();
        }
        else
         this.setState({...this.state,userrole: userrl, isFetching: false})
        

    }

    fetchExecutableProgramList = () => {
        this.setState({...this.state, isFetching: true});
        
        axios
        .get(configData.SERVER_URL+`fincorp_getExecutableProgramList` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*"
            }
        })
        .then(
            res=>  {this.setExecutableProgramList(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    };

    
    setExecutableProgramList=(result)=>{ 
        
        var rolelist= JSON.parse(localStorage.getItem("rolelocation"));
        console.log(rolelist);
        var primaryroleval=  localStorage.getItem("primaryrolesession");
        var programlist=[];
        _.forEach(result, function(value) {
            
            programlist.push({'value':''+value.id.toString(),'label':value.program_name})
            
            
        });
       
        

        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){            
            this.setState({listoptions: programlist,  isFetching: false});
            
        }
         
        

    }
    onListChange = (listselected) => {
        debugger;
        this.setState({ listselected });
    };

    handleChange = e => {
        let { value, name } = e.target;
        
        const date = new Date().toLocaleString().split(',')[0];
        this.setState({
            ...this.state,
            [name]: value,
            date

        });
        if(name=='search')
        {
            this.refs.table.handleFilterData({ name: value });
            // this.refs.table.handleFilterData({value});
        }
        else if(name=='status' && value=='Inactive'){
            const currentdate = new Date();
            currentdate.setDate(currentdate.getDate()-1);
            var momentDateObj = moment(currentdate).format('MM-DD-YYYY');
            var enddate=new Date(this.state.enddate);
            if(currentdate<enddate){
                var stdate=moment(this.state.startdate).format('MM-DD-YYYY')>moment(currentdate).format('MM-DD-YYYY')?moment(currentdate).format('MM-DD-YYYY'):moment(this.state.startdate).format('MM-DD-YYYY');

                this.setState({startdate:stdate, enddate:momentDateObj });
            }
            
        }
    };

    handleAddMember=()=>{
        this.state.process_name = '';
        this.state.process_status ='';
        this.state.startdate = '';
        this.state.enddate = '';
        this.state.process_owner = '';
        this.state.process_parameters = '';
        this.state.process_initial_starttime = '';
        this.state.sched_interval_min = '';
        this.state.auto_or_manual = '';
        this.state.seq_of_prog_id = '';
        this.state.listselected=[];

        this.state._id = undefined;
        this.setState({show: true, editshow:false });
    }
    handleClose=()=> {
        this.state.process_name = '';
        this.state.process_status ='';
        this.state.startdate = '';
        this.state.enddate = '';
        this.state.process_owner = '';
        this.state.process_parameters = '';
        this.state.process_initial_starttime = '';
        this.state.sched_interval_min = '';
        this.state.auto_or_manual = '';
        this.state.seq_of_prog_id = '';
        this.state.listselected=[];
        this.state._id = undefined;
        this.setState({ show: false });
    }
  
     handleClick = () => {
        this.change(this.state);
        this.setState(initialValues);
    };

     handleEditClick = (row,event) => {
debugger;
        this.state.process_name = row.original.process_name;
        this.state.process_status =row.original.process_status;
        this.state.startdate = row.original.startdate;
        this.state.enddate = row.original.enddate;
        this.state.process_owner = row.original.process_owner;
        this.state.process_parameters = row.original.process_parameters;
        this.state.process_initial_starttime = row.original.process_initial_starttime;
        this.state.sched_interval_min = row.original.sched_interval_min;
        this.state.auto_or_manual = row.original.auto_or_manual;
        this.state.seq_of_prog_id = row.original.seq_of_prog_id;

        this.state._id = row.original._id;
        this.state.listoptions=row.original.seq_list;
        this.state.listselected=row.original.seq_select_list;
        this.setState({ show: true, editshow: false });
       // this.props.history.push("/Item?id=" + row.id);
    };

     editImgFormatter = (cell, row) => {              
        return (
            <a
                className="editbutton"
                aria-label="Edit"
                onClick={() => this.handleEditClick(row)}
            >
                <i className="">
                    <img
                        alt="Edit"
                        className=""
                        src="/images/edit_icon.png"
                    />
                </i>
            </a>
        );
    }

     deleteImgFormatter = (cell, row) => {              
        return (
            <a
                className="deletebutton center"
                aria-label="Delete"
                onClick={() => this.handleDeleteClick(row)}
            >
                <i className="">
                    <img
                        alt="Delete"
                        className=""
                        src="/images/delete_icon.png"
                    />
                </i>
            </a>
        );
    }

    handleDeleteClick = (row,event) => {
        if(window.confirm('Are you sure to delete this record?')){ 
        //delete
        if (row.original._id!= undefined) {
            axios
                .post(configData.SERVER_URL + `fincorp_deleteExecutableProcess`,

                    { '_id': row.original._id }
                    , {
                        headers: {
                            "Content-Type": "application/json;charset=UTF-8",
                            "Access-Control-Allow-Origin": "*"
                        }
                    })
                .then(
                    res => this.reloadDataGrid(res.data)
                )
                .catch(err => {
                    console.log("AXIOS ERROR: ", err);
                });
        }
        else {
            //error            
            toast.warn("Executable Process Not Deleted");
        }
    }
    }
    reloadDataGrid = (res) => {

        toast.success("Executable Process Deleted Successfully");
        setTimeout(this.fetchexecutableprocesslist(), 4000);
    }

    onStartDateChange = (jsDate, dateString) => {
        this.setState(prevState => ({
           
                // object that we want to update
                ...prevState, // keep all other key-value pairs
                
                startdate: moment(dateString).format("MM-DD-YYYY")
                
           
        }));
    };
    onEndDateChange = (jsDate, dateString) => {
        this.setState(prevState => ({
           
                // object that we want to update
                ...prevState, // keep all other key-value pairs
                
                enddate: moment(dateString).format("MM-DD-YYYY")
                
           
        }));
    };

    handleSaveClick = (event) => {
         debugger;
        var userorgid= localStorage.getItem("userorgid");
         // 
        //  const regExDate = /^[0-9\/]+$/;      

        if(this.state.process_name ==undefined || this.state.process_name.length==0){
            toast.warn("Enter Process Name");
            event.preventDefault();        
        }
        else if(this.state.process_status ==undefined || this.state.process_status==' '|| this.state.process_status=='Select Status'){
            toast.warn("Choose Process Status");
            event.preventDefault();        
        }
        // else if(this.state.process_parameters ==undefined || this.state.process_parameters.length==0){
        //     toast.warn("Enter Process Parameters");
        //     event.preventDefault();        
        // }
         
        else if(this.state.process_owner ==undefined || this.state.process_owner =="" ){
            toast.warn("Select Process Owner");
            event.preventDefault();            
        }  
        else if(this.state.process_initial_starttime == undefined || this.state.process_initial_starttime ==""){
            toast.warn("Enter Initial Start Time");
            event.preventDefault();            
        } 
        else if (this.state.sched_interval_min == undefined || this.state.sched_interval_min == ""  ) {
            toast.warn("Enter Scheduled Interval Minutes");
            event.preventDefault();               
        }
        else if (this.state.auto_or_manual == undefined || this.state.auto_or_manual == "" || this.state.run_method=='Select Type' ) {
            toast.warn("Select Type Auto Or Manual");
            event.preventDefault();               
        }
        else if (this.state.startdate == undefined || this.state.startdate == "" || this.state.startdate == "Invalid date" ) {
            toast.warn("Enter Start Date");
             event.preventDefault();               
        }  
        // else if (this.state.seq_of_prog_id  == undefined || this.state.seq_of_prog_id  == ""  ) {
        //     toast.warn("Enter Sequence ID");
        //     event.preventDefault();               
        // }
        else if (Date.parse(this.state.startdate) > Date.parse(this.state.enddate)) {
            toast.warn("End Date should be greater than the StartDate");
            event.preventDefault();
        } 
        
        else {
           
            this.state.orgid=userorgid;
            
            //update existing Executable Process 
        if(this.state._id!=undefined){
            if(window.confirm('Do you want to save changes?')){   
                this.state.startdate=  this.state.startdate == "Invalid date"?null:this.state.startdate;
                this.state.enddate=  this.state.enddate == "Invalid date"?null:this.state.enddate;
            axios
            .post(configData.SERVER_URL+`fincorp_updateExecutableProcess`,
             
            {
                'process_name':this.state.process_name,
                'process_initial_starttime' : this.state.process_initial_starttime,  
                'process_owner' : this.state.process_owner,             
                'process_parameters' : this.state.process_parameters,
                'sched_interval_min' : this.state.sched_interval_min,             
                'auto_or_manual' : this.state.auto_or_manual,                            
                'startdate' : this.state.startdate,
                'enddate' : this.state.enddate,
                'process_status' : this.state.process_status,
                'seq_of_prog_id' : this.state.seq_of_prog_id,
                'orgid':this.state.orgid,
                '_id':this.state._id,
                'seq_select_list':this.state.listselected,
                'seq_list':this.state.listoptions
               }
            , {
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "Access-Control-Allow-Origin": "*"
                }
            })
            .then(
                res => this.UpdateChanges(res.data)
                
            )
            .catch(err => {
                console.log("AXIOS ERROR: ", err);
            });
            event.preventDefault();
            }
        }
                else{
                    
                    var lg=  this.state.originalexecutableprocesslist.length;
                    var tempid=lg!=0?this.state.originalexecutableprocesslist[lg-1].id+1:1;  
                //insert new Executable Process
                axios
                .post(configData.SERVER_URL+`fincorp_insertExecutableProcess`,
                
               {
                'process_name':this.state.process_name,
                'process_initial_starttime' : this.state.process_initial_starttime,  
                'process_owner' : this.state.process_owner,             
                'process_parameters' : this.state.process_parameters,
                'sched_interval_min' : this.state.sched_interval_min,             
                'auto_or_manual' : this.state.auto_or_manual,                            
                'startdate' : this.state.startdate,
                'enddate' : this.state.enddate,
                'process_status' : this.state.process_status,
                'seq_of_prog_id' : this.state.seq_of_prog_id,
                'orgid':this.state.orgid,
                '_id':undefined,
                'id':tempid,
                'seq_select_list':this.state.listselected,
                'seq_list':this.state.listoptions
               }
                , {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                .then(
                    res => this.SaveChanges(res)
                    
                    
                )
                .catch(err => {
                    console.log("AXIOS ERROR: ", err);
                });
                //event.preventDefault();
                }
        }
    
    };

    SaveChanges = (result) => {   
        debugger; 
        console.log(result);    
       if (result.Message!= undefined && (result.Message==-1))
          {
            toast.warning("Executable Process Alredy Exist");
          }
        else { 
        this.state._id=result;
        console.log(result);
        toast.success("Executable Process Inserted Successfully");
        setTimeout(this.ReloadData(), 4000);
        //setTimeout(()=>this.props.history.push("/ExecutableProcessslist"), 4000);  
        } 
    }
    ReloadData=()=>{
        this.fetchexecutableprocesslist();
        this.handleClose();
    }
    UpdateChanges = (result) => {
        
        if(result.Message!= undefined && (result.Message==-1)){
            toast.warn(result.Message);
        }
        else{
            toast.success("Executable Process Updated Successfully");
            setTimeout(this.ReloadData(), 4000);   
           
 
        }
   }
    
    fetchLabelMessagesAPI = () => {
        this.setState({...this.state, isFetching: true});
        
        axios
        .get(configData.SERVER_URL+`fincorp_getCustomMessage` 
        , {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*"
            }
        })
        .then(
            res=>  {this.setBindMessage(res.data) }
        )
        .catch(err => {
            console.log("AXIOS ERROR: ", err);
        });
    };

    setBindMessage=(result)=>{
        
        if(result!="No document(s) found with defined find criteria!" && result!=null &&result.length>0){
            
            this.setState({Labels: result, isFetching: false});
        }
        

    }
    handleChange1 = event => {
        
        this.setState({ searchInput: event.target.value }, () => {
          this.globalSearch();
        });
      };
      toggleChange = () => {
        this.setState({
            chkisactive: !this.state.chkisactive,
        });
        this.globalActiveSearch(!this.state.chkisactive) ;
      }

      globalActiveSearch = (param) => {
          
        let { searchInput } = this.state;    
        console.log(searchInput);  
        if(searchInput==undefined){
            searchInput='';
        }
debugger;
        let filteredData = this.state.originalexecutableprocesslist.filter(value => {
            if(param){               

                return (
                    (value.process_name.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.process_owner.toLowerCase().includes(searchInput.toLowerCase()) ||                     
                    value.process_parameters.toLowerCase().includes(searchInput.toLowerCase()) ||                    
                    value.process_initial_starttime.toLowerCase().includes(searchInput.toLowerCase()) ||                       
                    value.sched_interval_min.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.auto_or_manual.toLowerCase().includes(searchInput.toLowerCase()) || 
                    value.process_status.toLowerCase().includes(searchInput.toLowerCase()) ||     
                    value.seq_of_prog_id.toLowerCase().includes(searchInput.toLowerCase()) ||                                      
                    value.startdate.toLowerCase().includes(searchInput.toLowerCase()) ||
                    ( value.enddate!=undefined||value.enddate!=null? value.enddate.toString().toLowerCase().includes(searchInput.toLowerCase()):''))&&                                        
                    value.process_status.toString().includes('Active') 
                   
                );

            }else{
                return (
                    (value.process_name.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.process_owner.toLowerCase().includes(searchInput.toLowerCase()) ||                     
                    value.process_parameters.toLowerCase().includes(searchInput.toLowerCase()) ||                    
                    value.process_initial_starttime.toLowerCase().includes(searchInput.toLowerCase()) ||                       
                    value.sched_interval_min.toLowerCase().includes(searchInput.toLowerCase()) ||
                    value.auto_or_manual.toLowerCase().includes(searchInput.toLowerCase()) || 
                    value.process_status.toLowerCase().includes(searchInput.toLowerCase()) || 
                    value.seq_of_prog_id.toLowerCase().includes(searchInput.toLowerCase()) ||                                          
                    value.startdate.toLowerCase().includes(searchInput.toLowerCase()) ||
                    ( value.enddate!=undefined||value.enddate!=null? value.enddate.toString().toLowerCase().includes(searchInput.toLowerCase()):'')) ||                                      
                    value.process_status.toString().toLowerCase().includes(searchInput.toLowerCase())
          );
        }
        });
        this.setState({ executableprocesslist: filteredData });
      };
      globalSearch = () => {
          
        let { searchInput } = this.state;
        let filteredData = this.state.originalexecutableprocesslist.filter(value => {
        if(this.state.chkisactive){    
          return (

            (value.process_name.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.process_owner.toLowerCase().includes(searchInput.toLowerCase()) ||                     
            value.process_parameters.toLowerCase().includes(searchInput.toLowerCase()) ||                    
            value.process_initial_starttime.toLowerCase().includes(searchInput.toLowerCase()) ||                       
            value.sched_interval_min.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.auto_or_manual.toLowerCase().includes(searchInput.toLowerCase()) || 
            value.process_status.toLowerCase().includes(searchInput.toLowerCase()) ||  
            value.seq_of_prog_id.toLowerCase().includes(searchInput.toLowerCase()) ||                                         
            value.startdate.toLowerCase().includes(searchInput.toLowerCase()) ||
            ( value.enddate!=undefined||value.enddate!=null? value.enddate.toString().toLowerCase().includes(searchInput.toLowerCase()):''))&&                                        
            value.process_status.toString().includes('Active') 
                );
        }else{
            return (

                (value.process_name.toLowerCase().includes(searchInput.toLowerCase()) ||
                value.process_owner.toLowerCase().includes(searchInput.toLowerCase()) ||                     
                value.process_parameters.toLowerCase().includes(searchInput.toLowerCase()) ||                    
                value.process_initial_starttime.toLowerCase().includes(searchInput.toLowerCase()) ||                       
                value.sched_interval_min.toLowerCase().includes(searchInput.toLowerCase()) ||
                value.auto_or_manual.toLowerCase().includes(searchInput.toLowerCase()) || 
                value.process_status.toLowerCase().includes(searchInput.toLowerCase()) ||  
                value.seq_of_prog_id.toLowerCase().includes(searchInput.toLowerCase()) ||                                         
                value.startdate.toLowerCase().includes(searchInput.toLowerCase()) ||
                ( value.enddate!=undefined||value.enddate!=null? value.enddate.toString().toLowerCase().includes(searchInput.toLowerCase()):'')) ||                                      
                value.process_status.toString().toLowerCase().includes(searchInput.toLowerCase())
              );  
        }
        });
        this.setState({ executableprocesslist: filteredData });
      };

      handleSelectChange = selectedOption => {
         
        this.setState(prevState => ({
            ExecutableProcess: {
                ...prevState.ExecutableProcess,  
                role_name: selectedOption
            }
        }));
        
      };

    render() {
        const Labels=this.state.Labels!=null&& this.state.Labels!=undefined?this.state.Labels:[];
        let { data, columns, searchInput } = this.state; 
    return (
        <>
            <div className="container userinfo-container" role="main">
               
                <div className="centeralign">
                    <span className="mainheadings"> 
                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcessList_Title' && lbl.pageName=='ExecutableProcessList').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))} 
                    </span>
                </div>
                <div className="fullwidth">
                    <div className="float-left">
                    <button className={this.state.userrole.create=='Y'?"btn btn-primary  float-left ":"hidden"}  onClick={this.handleAddMember} >                    
                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcessList_Addbtn' && lbl.pageName=='ExecutableProcessList').map(filteredPerson => (
                        <span>
                        {filteredPerson.keyValue}
                        </span>
                    ))}
                        </button>
                    </div> 
                    <div className="float-right">
                    <div className="isactivecontainer" >
                            <span>Active</span>
                            <input type="checkbox" aria-label="Status Filter" className="chkisactive"
                            defaultChecked={this.state.chkisactive}
                            onChange={this.toggleChange}
                            />                            
                        </div>
                        <div className="float-left txtsearchcontainer">
                        <span className="searchlabel">
                        {Labels.filter(lbl => lbl.keyPair=='ExecutableProcessList_Search' && lbl.pageName=='ExecutableProcessList').map(filteredPerson => (
                            <span>
                            {filteredPerson.keyValue}
                            </span>
                        ))}
                        </span>
                        <Form.Control
                            aria-label="search"
                            type="text"
                            name="search"
                            value={searchInput || ""}
                            onChange={this.handleChange1}
                        />
                        </div>                        
                    </div>                     

                </div>
               <div className="fullwidth row m0">
                <div className="col-md-12 mt-10 p0">
                     <ReactTable
                    data={this.state.executableprocesslist}
                    columns={this.state.columns}
                    defaultPageSize={20}
                    className="-striped -highlight fullwidth"
                    />  
                </div>      
               </div>
                <div>
                <Modal
                        className="ExecutableProcess-modal"
                         show={this.state.show}
                         onHide={this.handleClose}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="margin_auto">
                            {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_Title' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                            <span>
                            {this.state._id==undefined?"Add":"Edit"} {filteredPerson.keyValue}
                            </span>
                            ))}                            
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Row >                                    
                                <Col md={6} className="row">
                            <Col md={4}>
                                    <Form.Label className="required" for="frmprocessname">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_Name' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                     <span>
                                        {filteredPerson.keyValue}
                                     </span>
                                    ))} 
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Control
                                        id="frmprocessname"
                                        type="text"
                                        className="form-control"
                                        controlId="processname"
                                        name="process_name"
                                        placeholder="Process Name"
                                        onChange={this.handleChange}
                                        value={this.state.process_name }                                       
                                        required
                                    />
                                </Col>
                            </Col>
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label  className="required" for="frmprocessstatus">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_Status' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>   
                                <Form.Control
                                        id="frmprocessstatus"
                                        as="select"
                                        name="process_status"
                                     value={this.state.process_status}
                                        onChange={this.handleChange}
                                        // aria-labelledby="frmexecutablestatus"
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </Form.Control>
                            </Col>
                            </Col>
                                </Form.Row>
                                    <Form.Row className="mt-10">
                                    <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label className="" for="frmprocessparameters">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_Parameter' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))} 
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                <Form.Control
                                        id="frmprocessparameters"
                                        type="text"
                                        className="form-control"
                                        controlId="processparameters"
                                        name="process_parameters"
                                        placeholder="Process Parameters"
                                        onChange={this.handleChange}
                                        value={this.state.process_parameters }                                       
                                        // required
                                    >
                                    </Form.Control>
                                </Col>
                            </Col>
                            <Col md={6} className="row" >
                            <Col md={4}>
                                <Form.Label className="required" for="owner">
                                     {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_Owner' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                     <span>
                                        {filteredPerson.keyValue}
                                     </span>
                                    ))}  
                                </Form.Label>{" "}
                                </Col>
                                <Col md={8}>   
                                <Form.Control
                                            id="owner"
                                            className="form-control"
                                            as="textarea"
                                            rows="1"
                                            name="process_owner"
                                            placeholder="Owner"
                                             value={this.state.process_owner}
                                            onChange={this.handleChange}
                                            required
                                            
                                        />
                                </Col>
                            </Col>
                                    </Form.Row>
                                    <Form.Row className="mt-10">
                                    <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label className="required" for="frmprocesslocation">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_InitialStartTime' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                <Form.Control
                                        id="frminitialstarttime"
                                        type="text"
                                        className="form-control"
                                        controlId="initialstarttime"
                                        name="process_initial_starttime"                                       
                                        placeholder="Initial Start Time"
                                        onChange={this.handleChange}
                                        value={this.state.process_initial_starttime }
                                        required
                                    >
                                    </Form.Control>
                                </Col>
                            </Col>                           
                        <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label className="required" for="frmscheduleinterval">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_ScheduleInterval' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                <Form.Control
                                        id="frmscheduleinterval"
                                        type="text"
                                        className="form-control"
                                        controlId="scheduleinterval"
                                        name="sched_interval_min"                                        
                                        placeholder="Schedule Interval"
                                        onChange={this.handleChange}
                                        value={this.state.sched_interval_min }
                                        required
                                    >
                                    </Form.Control>
                                </Col>    
                            </Col>                                       
                            </Form.Row>

                            <Form.Row className="mt-10">
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label className="required" for='startdate'>
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_StartDate' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                <DatePickerInput
                                            id="startdate"
                                            name="startdate"
                                            onChange={this.onStartDateChange.bind(this, 'startdate') }
                                            placeholder="MM/DD/YYYY"
                                            value={this.state.startdate}
                                            minDate={moment().toDate()}
                                            className="my-custom-datepicker-component"
                                            readOnly
                                        />                                    
                                </Col>                                
                            </Col>
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label for='enddate'>
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_EndDate' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>
                                <DatePickerInput
                                            id="enddate"
                                            name="enddate"
                                            //onChange={this.onEndDateChange}
                                            onChange={this.onEndDateChange.bind(this, 'enddate') }
                                            placeholder="MM/DD/YYYY"
                                            value={this.state.enddate}
                                            minDate={moment().toDate()}
                                            className="my-custom-datepicker-component"
                                            readOnly
                                        />
                                </Col>
                               </Col>                               
                            </Form.Row>  
                            <Form.Row className="mt-10">
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label  className="required" for="frmprocesstype">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_AutoOrManual' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label>
                                </Col>
                                <Col md={8}>   
                                <Form.Control
                                        id="frmprocesstype"
                                        as="select"
                                        controlId="processtype"
                                        type="text"
                                        name="auto_or_manual"
                                        value={this.state.auto_or_manual}
                                        placeholder="Process Type"
                                        onChange={this.handleChange}

                                    >
                                        <option value="">Select Type</option>
                                        <option value="Auto">Auto</option>
                                        <option value="Manual">Manual</option>
                                       
                                                                        
                                    </Form.Control>
                            </Col>
                            </Col>
                            <Col md={6} className="row">
                                <Col md={4}>
                               {/* <Form.Label  className="required" for="frmprocesstype">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_SequenceID' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label> */}
                                </Col>
                                <Col md={8}>   
                                {/* <Form.Control
                                        id="frmprocesstype"
                                        controlId="seq_of_prog_id"
                                        type="text"
                                        name="seq_of_prog_id"
                                        value={this.state.seq_of_prog_id}
                                        placeholder="Sequence ID"
                                        onChange={this.handleChange}
                                       
                                    >                                      
                                    </Form.Control> */}
                            </Col>
                            </Col>
                                                        
                            </Form.Row>
                            <Form.Row className="mt-10">
                            <Col md={6} className="row">
                                <Col md={4}>
                                <Form.Label  className="required" for="frmprocesstype">
                                    {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_SequenceList' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                    {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                    </Form.Label> 
                                </Col>
                                <Col md={8}>
                                <DualListBox
                                options={this.state.listoptions}
                                selected={this.state.listselected}
                                onChange={this.onListChange}
                                preserveSelectOrder 
                                />
                                </Col>
                                </Col>
                           </Form.Row>
                         </Form>
                            </Modal.Body>
                            <Modal.Footer>
                               
                                <Button variant="primary" onClick={this.handleSaveClick}>
                                   Save {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_SaveBtn' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                        {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                </Button>
                                 <Button variant="secondary" onClick={this.handleClose} >
                                  Cancel  {Labels.filter(lbl => lbl.keyPair=='ExecutableProcess_CancelBtn' && lbl.pageName=='ExecutableProcessSetup').map(filteredPerson => (
                                    <span>
                                        {filteredPerson.keyValue}
                                    </span>
                                    ))}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        
                </div>
   
                
            </div>
        </>
    );
    }
}

